import styled from '@emotion/styled'
import { Link } from 'gatsby'
import { COLORS, MQ, SPACERS } from 'utils/styleHelpers'

export const ErrorMessage = styled.div`
	color: ${COLORS.RED};
	padding-top: 5px;
`
export const StyledButton = styled.button`
	color: ${COLORS.WHITE};
	background: ${({ bg }) => {
		return bg || COLORS.BLACK
	}};
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 16px;
	padding: 14px 28px;
	text-align: center;
	width: 100%;
	transition: background 0.5s;
	.dark & {
		background: ${({ bg }) => (bg === COLORS.BLACK ? COLORS.DARK_BLACK : bg)};
	}
`
export const FormHeader = styled.h2`
	padding-left: ${SPACERS.S};
	text-transform: uppercase;
`

export const StyledSubmitButton = styled.input`
	background-color: ${({ bg }) => {
		return bg || COLORS.BLACK
	}};
	border: none;
	cursor: pointer;
	font-size: 16px;
	display: block;
	padding: 14px 28px;
	text-align: center;
	type: submit;
	width: 100%;
`
export const StyledLink = styled(Link)`
	color: ${COLORS.BLACK};
	&:hover {
		text-decoration: underline;
	}
	transition: color 0.5s;
	.dark & {
		color: ${COLORS.WHITE};
	}
`
export const ReviewsListWrapper = styled.div``
export const ReviewFormWrapper = styled.div`
	${MQ.S} {
		margin-right: ${SPACERS.L};
		min-width: 200px;
	}
	${MQ.M} {
		min-width: 300px;
	}
	${MQ.L} {
		margin-right: ${SPACERS.XL};
		min-width: 400px;
	}
`

export const StyledStar = styled.div`
	font-size: ${({ fontSize }) => fontSize};
	margin-right: 3px;
`
